import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownloadStatusLoadingCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#999",
		d: "M8.57 19.677a9.132 9.132 0 0 1-3.35-1.01 9.54 9.54 0 0 1-2.68-2.09A9.613 9.613 0 0 1 .765 13.67a9.364 9.364 0 0 1-.644-3.458c0-2.448.806-4.572 2.418-6.37C4.15 2.04 6.17 1.01 8.595.745v1.5C6.585 2.53 4.92 3.424 3.6 4.93c-1.32 1.504-1.98 3.265-1.98 5.28 0 2.017.658 3.778 1.975 5.283C4.91 17 6.57 17.894 8.57 18.177v1.5Zm2 0v-1.5a8.358 8.358 0 0 0 2.062-.56 7.991 7.991 0 0 0 1.838-1.07l1.104 1.084a10.228 10.228 0 0 1-5.004 2.046Zm3.95-15.78a9.24 9.24 0 0 0-1.863-1.076 7.986 7.986 0 0 0-2.062-.575v-1.5a9.858 9.858 0 0 1 2.628.679c.839.346 1.622.802 2.35 1.367L14.52 3.896Zm2.454 12.284-1.054-1.07a7.885 7.885 0 0 0 1.05-1.837c.266-.658.45-1.346.55-2.063h1.53c-.12.913-.352 1.793-.697 2.64a9.034 9.034 0 0 1-1.38 2.33Zm.546-6.97a8.658 8.658 0 0 0-.55-2.062 7.888 7.888 0 0 0-1.05-1.838l1.073-1.088a9.85 9.85 0 0 1 1.366 2.348c.348.848.579 1.728.691 2.64h-1.53Z"
	})
});
export { SvgDownloadStatusLoadingCircle as ReactComponent };
